import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService, PRODUCT_NORMALIZER } from '@spartacus/core';
import { BehaviorSubject, catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MyQuotesService {
  cancelQuoteMsg = new BehaviorSubject(null);
  constructor(private http:HttpClient, private occEndpointsService: OccEndpointsService,private converterService:ConverterService) { }

  getMyQuotesList(unit='0001017486_0313_20_00', pageSize=0){
    return this.http.get(this.occEndpointsService.buildUrl(`quote/myquotes?unit=${unit}&page=${pageSize}`));
  }



  getQuoteDetails(code) {
    return this.http.get(this.occEndpointsService.buildUrl(`quote/myquotes/details?quoteCode=${code}`)).pipe(
      map((res: any) => {
        if (res && res.entries) {
          res.entries = res.entries.map((entry) => {
            entry.product = this.converterService.convert(entry.product, PRODUCT_NORMALIZER);
            return entry;
          });
        }
        return res;
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }



  deleteEntries(code, entryNbr){
    return this.http.get(this.occEndpointsService.buildUrl(`quote/deleteEntry?entryNumber=${entryNbr}&quoteCode=${code}`));
  }
}
